import Component from '@glimmer/component';
import RouteTemplate from 'ember-route-template';
import { LinkTo } from '@ember/routing';
import { service } from '@ember/service';
import { action } from '@ember/object';
import { on } from '@ember/modifier';

class FourOhFourRouteComponent extends Component {
  @service metrics;
  @service router;

  constructor() {
    super(...arguments);
    // Track 404 page views with attempted route
    const attemptedRoute = window.location.pathname;
    this.metrics.track('404_page_view', {
      attempted_route: attemptedRoute,
      referrer: document.referrer,
    });
  }

  @action
  goBack() {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      this.router.transitionTo('index');
    }
  }
  <template>
    <main class='layout-content-full'>
      <div class='error-display grid-limit'>
        <figure class='error-img liquid'>
          <img src='/img/other/error-img.png' alt='404 Error illustration' />
        </figure>
        <h1 class='error-title'>Page Not Found</h1>
        <p class='error-subtitle'>The page you're looking for doesn't exist</p>
        <p class='error-text'>The page you are looking for has been moved or doesn't exist anymore. You can
          return to the previous page, or go to our main homepage. If the problem persists, please send an email to
          <a class='highlight' href='mailto:admin@1vX.gg' aria-label='Contact support at admin@1vX.gg'>admin@1vX.gg</a></p>
      </div>
      <nav class='section-actions' aria-label='Navigation options'>
        <button type='button' class='button secondary' {{on 'click' this.goBack}} aria-label='Go back to previous page'>
          Go Back
          <div class='button-ornament'>
            <svg class='arrow-icon medium' aria-hidden='true'>
              <use href='#svg-arrow-medium'></use>
            </svg>
          </div>
        </button>
        <LinkTo @route='index' class='button violet' aria-label='Go to homepage'>
          Go to Homepage
          <div class='button-ornament'>
            <svg class='arrow-icon medium' aria-hidden='true'>
              <use href='#svg-arrow-medium'></use>
            </svg>
          </div>
        </LinkTo>
      </nav>
    </main>
  </template>
}
export default RouteTemplate(FourOhFourRouteComponent);
